module.exports = __webpack_public_path__ + "img/intro-02.2da072be.png";